<template>
  <div>
    <!-- {{ filterTopPartnerList }} -->
    <router-view></router-view>
  </div>
</template>

<script>
// import "./stroe";
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {};
  },
  watch: {
    $route: {
      handler(val, oldVal) {
        // console.log("val",val);
        // console.log("oldVal",oldVal);
        if (oldVal) {
          if (val.path !== oldVal.path) {
            this.setTopPartner('');
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapMutations("topPartner", ["setTopPartner"]),
    ...mapActions("topPartner", ["getTopPartner"]),
  },
  computed: {
    ...mapGetters("topPartner", ["filterTopPartnerList"]),
  },
  mounted() {
    // this.getTopPartner({ page:1, size:100000, channelUserId:'', phone:'', email:'' })
    // localStorage.setItem('topPartner',this.filterTopPartnerList?this.filterTopPartnerList[0].channelUserId:'')
    // this.setTopPartner(this.filterTopPartnerList?this.filterTopPartnerList[0].channelUserId:'')
  },
};
</script>

<style lang="less" scoped></style>
